import { Route } from 'react-router-dom';
import { SentryRoutes } from '@/sentry';
import AppMain from '../App';
import Layout from '@/components/layout/Layout';
import Login from '@/features/auth/pages/Login';
import ActivateTFA from '@/features/auth/pages/ActivateTFA';
import ForgotPassword from '@/features/auth/pages/ForgotPassword';
import ResetPassword from '@/features/auth/pages/ResetPassword';
import Auth from '@/features/auth/components/Auth';
import Register from '@/features/auth/pages/Register';
import NotFound from '@/features/routing/pages/NotFound';
import mapRoutes from '../features/routing/RoutesRenderer';
import { clientItems } from './client.nav';
import mapAliases from '@/features/routing/AliasesRenderer';
import {
  collectRouteAliasPatterns,
  setRouteAliasPatterns,
} from '@/features/routing/formatRouteAliasLabel';

setRouteAliasPatterns(collectRouteAliasPatterns(clientItems));

const App = () => (
  <AppMain>
    <SentryRoutes>
      <Route path="login" element={<Login />} />
      <Route path="register" element={<Register />} />
      <Route path="activate2fa" element={<ActivateTFA />} />
      <Route path="forgotpassword" element={<ForgotPassword />} />
      <Route path="resetpassword" element={<ResetPassword />} />

      <Route
        element={
          <Auth app="user">
            <Layout
              routes={clientItems}
              useClientTopbarActions
              includeSearch
              displayInitialModals
            />
          </Auth>
        }
      >
        {mapRoutes({ routes: clientItems })}
        {mapAliases({ routes: clientItems })}
        <Route path="*" element={<NotFound />} />
      </Route>
    </SentryRoutes>
  </AppMain>
);

export default App;
